import './AutocompleteOverlay-d99d778c.css';

var classes = {"Overlay":"prc-Autocomplete-Overlay-4kapX"};

export { classes as default };
